import { Component, OnInit } from '@angular/core';
import {AuthInfo} from "../shared/security/auth-info";
import {AuthService} from "../shared/security/auth.service";

@Component({
  selector: 'transition',
  templateUrl: './transition.component.html',
  styleUrls: ['./transition.component.css']
})
export class TransitionComponent implements OnInit {

  authInfo:AuthInfo;

  constructor(private authService:AuthService) { }

  ngOnInit() {
    this.authService.authInto$
      .subscribe(authInfo => this.authInfo = authInfo);
  }

}



// WEBPACK FOOTER //
// ./src/app/transition/transition.component.ts